import { httpClient } from '../http';
import {
  VersionProgressStat,
  VersionTrendStat,
  VersionErrorDistributionStat,
  RolloutProgressStat,
  UpgradeStatisticsStat,
  UpgradeTrendStat,
  UpgradeStatusDistributionStat,
  DailyUpgradeDistributionStat,
  DeviceOverviewStat,
  ModelDistributionStat,
  RegionTopDistributionStat,
  VersionDistributionStat,
  VersionDetailDistributionStat,
} from '@/types/api';

export class StatsAPI {
  // 版本整体进度
  async getVersionProgress(model_id: number, version: string): Promise<VersionProgressStat> {
    const res = await httpClient.get<VersionProgressStat>('/admin/stats/version-progress', {
      model_id,
      version,
    });
    return res.data;
  }

  // 发布进度趋势
  async getVersionTrend(model_id: number, version: string): Promise<VersionTrendStat> {
    const res = await httpClient.get<VersionTrendStat>('/admin/stats/version-trend', {
      model_id,
      version,
    });
    return res.data;
  }

  // 错误类型分布
  async getVersionErrorDistribution(
    model_id: number,
    version: string,
  ): Promise<VersionErrorDistributionStat> {
    const res = await httpClient.get<VersionErrorDistributionStat>(
      '/admin/stats/version-error-distribution',
      { model_id, version },
    );
    return res.data;
  }

  // 灰度发布进度
  async getRolloutProgress(model_id: number, version: string): Promise<RolloutProgressStat> {
    const res = await httpClient.get<RolloutProgressStat>('/admin/stats/rollout-progress', {
      model_id,
      version,
    });
    return res.data;
  }

  // 升级统计数据
  async getUpgradeStatistics(params?: {
    time_range?: 'today' | 'last_7_days' | 'last_30_days' | 'last_90_days';
    start_time?: number;
    end_time?: number;
  }): Promise<UpgradeStatisticsStat> {
    const res = await httpClient.get<UpgradeStatisticsStat>('/admin/stats/upgrade-statistics', params);
    return res.data;
  }

  // 升级趋势数据
  async getUpgradeTrend(params?: {
    time_range?: 'today' | 'last_7_days' | 'last_30_days' | 'last_90_days';
    start_time?: number;
    end_time?: number;
  }): Promise<UpgradeTrendStat> {
    const res = await httpClient.get<UpgradeTrendStat>('/admin/stats/upgrade-trend', params);
    return res.data;
  }

  // 升级状态分布
  async getUpgradeStatusDistribution(params?: {
    time_range?: 'today' | 'last_7_days' | 'last_30_days' | 'last_90_days';
    start_time?: number;
    end_time?: number;
  }): Promise<UpgradeStatusDistributionStat> {
    const res = await httpClient.get<UpgradeStatusDistributionStat>(
      '/admin/stats/upgrade-status-distribution',
      params,
    );
    return res.data;
  }

  // 每日升级分布
  async getDailyUpgradeDistribution(params?: {
    time_range?: 'today' | 'last_7_days' | 'last_30_days' | 'last_90_days';
    start_time?: number;
    end_time?: number;
  }): Promise<DailyUpgradeDistributionStat> {
    const res = await httpClient.get<DailyUpgradeDistributionStat>(
      '/admin/stats/daily-upgrade-distribution',
      params,
    );
    return res.data;
  }

  // 设备概况
  async getDeviceOverview(params?: {
    time_range?: 'today' | 'last_7_days' | 'last_30_days' | 'last_90_days';
    start_time?: number;
    end_time?: number;
  }): Promise<DeviceOverviewStat> {
    const res = await httpClient.get<DeviceOverviewStat>('/admin/stats/device-overview', params);
    return res.data;
  }

  // 机型分布
  async getModelDistribution(): Promise<ModelDistributionStat> {
    const res = await httpClient.get<ModelDistributionStat>('/admin/stats/model-distribution');
    return res.data;
  }

  // 地区分布 TOP 10
  async getRegionTop10(): Promise<RegionTopDistributionStat> {
    const res = await httpClient.get<RegionTopDistributionStat>('/admin/stats/region-top10');
    return res.data;
  }

  // 版本分布（TOP 10 + 其他）
  async getVersionDistribution(params?: { model_id?: number }): Promise<VersionDistributionStat> {
    const res = await httpClient.get<VersionDistributionStat>('/admin/stats/version-distribution', params);
    return res.data;
  }

  // 版本详细分布（TOP 7 + 其他）
  async getVersionDetailDistribution(params?: { model_id?: number }): Promise<VersionDetailDistributionStat> {
    const res = await httpClient.get<VersionDetailDistributionStat>('/admin/stats/version-detail-distribution', params);
    return res.data;
  }

  // 导出指定版本的设备列表
  async exportDevicesByVersion(params: { version: string; model_id?: number }): Promise<{ url: string; file_id?: number; file_name?: string; file_size?: number }> {
    const res = await httpClient.get<{ url: string; file_id?: number; file_name?: string; file_size?: number }>('/admin/stats/export-devices-by-version', params);
    return res.data;
  }
}

export const statsAPI = new StatsAPI();


